import React from "react";
import styled, { keyframes } from "styled-components";

import { Container, PhotoFrame as BasePhotoFrame, TextStack } from "../styles";

const pulse = keyframes`
  50% {
    opacity: 0.5;
  }
`;

const SkeletonContainer = styled(Container)`
  box-sizing: border-box;
  padding: 4px;
  gap: 12px;
`;

const PhotoFrame = styled(BasePhotoFrame)`
  border-radius: 8px;
  aspect-ratio: 1;
  animation: ${pulse} 2s cubic-bezier(0.4, 0, 0.6, 1) infinite;
`;

const Pulse = styled.div`
  animation: ${pulse} 2s cubic-bezier(0.4, 0, 0.6, 1) infinite;
  border-radius: 4px;
  background-color: ${({ theme }) =>
    theme.globalConstants.color.backgroundGray};
`;

const NameLine = styled(Pulse)`
  width: 66.6667%;
  height: 20px;
`;

const BioLine = styled(Pulse)`
  width: 75%;
  height: 16px;
`;

const SkeletonTextStack = styled(TextStack)`
  min-height: 44px;
  gap: 8px;
`;

const SkeletonProfileCell: React.FC = () => (
  <SkeletonContainer>
    <PhotoFrame />

    <SkeletonTextStack>
      <NameLine />
      <BioLine />
    </SkeletonTextStack>
  </SkeletonContainer>
);

export default SkeletonProfileCell;
